import type { ReactNode } from 'react';

import type { FaultedDevice } from '@/features/equipment-browser/faulted-devices/faulted-devices.types';
import { getEquipmentTypeLabel } from '@/features/equipment-browser/faulted-devices/faulted-devices.utils';
import { Typography } from '@/ux-common/components/typography/typography';

interface ResetFaultedTypeCellProps {
  device: FaultedDevice;
}

/** The device's equipment type. */
export const ResetFaultedTypeCell = ({ device }: ResetFaultedTypeCellProps): ReactNode => (
  <Typography
    as="span"
    className="flex items-center h-full text-body-sm text-foreground truncate px-gutter-sm"
    data-component="ResetFaultedTypeCell"
  >
    {getEquipmentTypeLabel(device.summary.kind)}
  </Typography>
);
